import React from 'react'

const BankruptcyCasesRow = ({meta}) => (
    <tr>
        <td>{meta.case_title}</td>
        <td>{meta.court_code}</td>
        <td className="ir-search-no-wrap"><a href={"/filings/" + meta.case_uuid} target="_blank">{meta.case_no}</a></td>
        <td>{meta.chapter}</td>
        <td>{meta.date_filed}</td>
        <td>{meta.date_closed}</td>
        <td>{meta.disposition}</td>
    </tr>
)

export default BankruptcyCasesRow



/** WEBPACK FOOTER **
 ** ./src/components/search/results/BankruptcyCasesRow.js
 **/